var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.radio,attrs:{"role":"radio","aria-checked":_vm.isSelected.toString(),"tabindex":"0"},on:{"click":function($event){return _vm.handleClick()},"keydown":_vm.handleKeyDown}},[_vm._t("default",[_vm._v("Base tab header")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }